import { lazy } from 'react';

const PagesRoutes = [
  {
    path: '/login',
    component: lazy(() => import('../../views/authentication/Login')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },

  {
    path: '/login-mfa',
    component: lazy(() => import('../../views/authentication/Mfa/Mfa')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    //For force change password after register by admin
    path: '/change-password',
    component: lazy(() => import('../../views/authentication/ChangePassword')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    //For user change password after password is expired
    path: '/edit-password',
    component: lazy(() => import('../../views/authentication/EditPassword')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    //For user signing on terms
    path: '/confirm-terms',
    component: lazy(() => import('../../views/authentication/ConfirmTerms')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },

  {
    path: '/register',
    component: lazy(() => import('../../views/authentication/Register')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/confirm-email',
    component: lazy(() =>
      import('../../views/authentication/RegisterConfirmEmail')
    ),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/confirm-phone',
    component: lazy(() =>
      import('../../views/authentication/ConfirmPhonePage')
    ),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/confirm-phone-code',
    component: lazy(() =>
      import('../../views/authentication/ConfirmPhoneCodePage')
    ),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/email-confirmation',
    component: lazy(() =>
      import('../../views/authentication/EmailConfirmation')
    ),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },

  {
    path: '/additional-info',
    component: lazy(() =>
      import('../../views/authentication/RegisterAdditionalInfo')
    ),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('../../views/authentication/ForgotPassword')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/reset-password',
    component: lazy(() => import('../../views/authentication/ResetPassword')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/two-steps-verification',
    component: lazy(() =>
      import('../../views/authentication/TwoStepVerification')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/two-steps-code',
    component: lazy(() => import('../../views/authentication/TwoStepCode')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/account-settings',
    component: lazy(() => import('../../views/pages/AccountSettings')),
  },
  {
    path: '/privacy-policy',
    component: lazy(() => import('../../views/pages/PrivacyPolicy')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/terms',
    component: lazy(() => import('../../views/pages/Terms')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
];

export default PagesRoutes;
